module.exports = __webpack_public_path__ + "static/img/hoverlogo01.a457f3c0.png";